import { action } from 'typesafe-actions';

import * as types from './types';

export const fetchThemes = () => action(types.FETCH_THEMES);
export const fetchThemesSuccess = (data: any) => action(types.FETCH_THEMES_SUCCESS, data);
export const fetchThemesError = (error: any) => action(types.FETCH_THEMES_ERROR, error);
export const fetchTheme = (slug: string) => action(types.FETCH_THEME, { slug });
export const fetchThemeSuccess = (data: any) => action(types.FETCH_THEME_SUCCESS, data);
export const fetchThemeError = (error: any) => action(types.FETCH_THEME_ERROR, error);
